var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCardMeets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#E9F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.5963 26.6198H22.7083V23.4848H25.8763V21.3948H22.7083V18.2598H20.5963V21.3948H17.4283V23.4848H20.5963V26.6198ZM15.3163 30.7998C14.7355 30.7998 14.2385 30.5953 13.8252 30.1864C13.4113 29.7767 13.2043 29.2845 13.2043 28.7098V16.1698C13.2043 15.595 13.4113 15.1032 13.8252 14.6942C14.2385 14.2846 14.7355 14.0798 15.3163 14.0798H27.9883C28.5691 14.0798 29.0665 14.2846 29.4804 14.6942C29.8937 15.1032 30.1003 15.595 30.1003 16.1698V20.8723L34.3243 16.6923V28.1873L30.1003 24.0073V28.7098C30.1003 29.2845 29.8937 29.7767 29.4804 30.1864C29.0665 30.5953 28.5691 30.7998 27.9883 30.7998H15.3163Z",
    fill: "#2489F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardMeets);
export default __webpack_public_path__ + "static/media/iconCardMeets.d1c6c27bf7f7d01c4737c8087f171535.svg";
export { ForwardRef as ReactComponent };